import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Submit/RESEND_CODE_ERROR',
    PENDING: 'Submit/RESEND_CODE_PENDING',
    SUCCESS: 'Submit/RESEND_CODE_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
